//ImageBUlkUpload.js
import React from 'react';
import * as XLSX from 'xlsx';
import { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import axiosInstance from '../../utilities/axiosInstance';
import { showAlert } from "../../components/AlertPopup";
import { DOMAIN } from '../../Constant';

function ImageBUlkUpload() {

    let [excelFile, setExcelFile] = useState(null);
    let [zipFile, setZipFile] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const excelInputRef = useRef(null);
    const zipInputRef = useRef(null);
    const [jobId, setJobId] = useState(null);

    let handleDownloadClick = () => {
        // Reference the Excel file in the public/template folder
        let excelFileUrl = process.env.PUBLIC_URL + `/Template/bulkuploadtemplate.xlsx`;
        // Create a dummy anchor element to trigger the download
        let anchor = document.createElement('a');
        anchor.href = excelFileUrl;
        anchor.download = `bulkuploadtemplate.xlsx`; // Set the desired file name
        anchor.style.display = 'none';
        // Append the anchor to the document and trigger a click event
        document.body.appendChild(anchor);
        anchor.click();
        // Remove the anchor from the document
        document.body.removeChild(anchor);
    };
    let isExcelFile = (file) => {
        return file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx');
    };
    const [excelFileName, setExcelFileName] = useState("");

    let handleFileChange = async (event) => {
        let file = event.target.files[0];
        if (file) {
            setExcelFileName(file.name);
            if (isExcelFile(file)) {
                try {
                    let workbook = await readExcelFile(file);
                    let sheetName = workbook.SheetNames[0];
                    let worksheet = workbook.Sheets[sheetName];
                    let range = XLSX.utils.decode_range(worksheet['!ref']);
                    if (range.e.r >= range.s.r + 1) {
                        for (let rowIndex = range.s.r + 1; rowIndex <= range.e.r; rowIndex++) {
                            // Removed 'I' from required columns
                            let requiredColumns = ['A', 'B', 'D', 'F'];
                            let optionalColumns = ['C', 'E', 'G', 'H', 'I'];

                            let isRowValid = requiredColumns.every(column => {
                                let cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: column.charCodeAt(0) - 65 })];
                                let isValid = cell && cell.v !== undefined && cell.v !== null && String(cell.v).trim() !== '';
                                console.log(`Row: ${rowIndex + 1}, Column: ${column}, Valid: ${isValid}`);
                                return isValid;
                            });

                            optionalColumns.forEach(column => {
                                let cell = worksheet[XLSX.utils.encode_cell({ r: rowIndex, c: column.charCodeAt(0) - 65 })];
                                if (cell && (cell.v === undefined || cell.v === null || String(cell.v).trim() === '')) {
                                    console.log(`Optional column ${column} is empty in row ${rowIndex + 1}`);
                                }
                            });

                            if (!isRowValid) {
                                console.log(`Row ${rowIndex + 1} has missing values in required columns.`);
                                alert(`Please fill all required columns (A, B, D, F) for row ${rowIndex + 1} in the Excel file.`);
                                return;
                            }
                        }
                        setExcelFile(file);
                    } else {
                        alert('Not enough data rows found below the headers. <br/> Please upload a valid Excel file with data.');
                    }
                } catch (error) {
                    alert('An error occurred while processing the Excel file.');
                    console.error(error);
                }
            } else {
                alert('Please upload a valid Excel file with data.');
                event.target.value = '';
            }
        }
    };

    const [zipFileName, setZipFileName] = useState("");



    let handleZipFileChange = (event) => {
        let file = event.target.files[0];
        if (file) {
            setZipFileName(file.name);
            // Check if the selected file has a valid ZIP file extension
            let allowedExtensions = ['.zip'];
            let fileName = file.name.toLowerCase();
            let isValidExtension = allowedExtensions.some(extension => fileName.endsWith(extension));
            if (isValidExtension) {
                // Handle the valid ZIP file here
                setZipFile(file);
            } else {
                alert('Please select a valid ZIP file');
                // Clear the file input field
                event.target.value = '';
            }
        }
    };

    let readExcelFile = (file) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (e) => {
                let data = new Uint8Array(e.target.result);
                let workbook = XLSX.read(data, { type: 'array' });
                resolve(workbook);
            };
            reader.readAsArrayBuffer(file);
        });
    };

    /*let showAlert = (title, arg, icon = 'info') => {
        Swal.fire({
            title: title,
            text: arg,
            icon: icon,
            confirmButtonText: 'OK',
        });
    };*/

    let handleUploadClick = async (e) => {
        if (!excelFile || !zipFile) {
            alert('Please select both an Excel file and a ZIP file before uploading.');
            return;
        }

        setIsLoading(true);

        try {
            const workbook = await readExcelFile(excelFile);
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const excelData = XLSX.utils.sheet_to_json(worksheet);

            const formattedExcelData = excelData.map(item => ({
                "project_name": item.project_name,
                "assignNameOftaggers": item.assignNameOftaggers
            }));

            const checkResponse = await axiosInstance.get(`/bulkuploadcheck`, {
                params: { args: formattedExcelData[0]['project_name'] }
            });

            if (checkResponse.data.resargs.project_status <= 0) {
                showAlert('Info', 'Manager not belong to project.', 'info');
                return;
            }

            const formDataExl = new FormData();
            formDataExl.append('excelData', JSON.stringify(excelData));
            await axiosInstance.post(`/v3/excelupload`, formDataExl, {
                headers: {
                    'Content-Type': 'application/json',
                }
            }).then(async (resExcel) => {
                console.log(resExcel.data.insertedIds);
                const formData = new FormData();
                formData.append('zipFile', zipFile);
                formData.append('body', JSON.stringify(excelData));
                formData.append('insertedIds', JSON.stringify(resExcel.data.insertedIds));
                try {
                    const resZip = await axiosInstance.post(`/v5/image-zip-extraction`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    console.log("resZip.data===>", resZip.data);
                    setJobId(resZip.data.jobId); // ✅
                    showAlert('Success', resZip.data, 'success');
                } catch (zipError) {
                    showAlert('Error', zipError.response?.data?.message || 'ZIP upload failed', 'error');
                    await axiosInstance.delete(`/delZipTask`, {
                        data: { details: formattedExcelData }
                    });
                }
            });




        } catch (error) {
            showAlert('Error', error.response?.data?.message || error.message, 'error');
        } finally {
            setIsLoading(false);
            setExcelFile(null);
            setZipFile(null);
            if (excelInputRef.current) excelInputRef.current.value = '';
            if (zipInputRef.current) zipInputRef.current.value = '';
        }
    };

    useEffect(() => {
    }, [excelFile]);

    useEffect(() => {
    }, [zipFile]);


    useEffect(() => {
        if (!jobId) return;

        if (jobId) {
            const sse = new EventSource(`${DOMAIN}/api/job-events/${jobId}`);
            sse.onmessage = (event) => {
                const data = JSON.parse(event.data);
                console.log("onmessage===>", data);
                if (data.status === 'completed') {
                    showAlert('✅ Job completed!', data.status, 'success');
                    sse.close();
                }
            };
            sse.onerror = (err) => {
                console.error('SSE error:', err);
                sse.close();
            };
            return () => sse.close();
        }

    }, [jobId]);


    return (
        <div className='max-w-[650px] mx-auto mt-5'>
            <div className='flex items-center'>
                <button
                    id="downloadTopButton"
                    className="w-[250px] h-[60px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                    onClick={handleDownloadClick}
                >
                    Download Image Template
                </button>
            </div>
            <div>
                <span className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                    Upload the Excel:
                </span>

                <div className="relative w-full mt-[5px] mb-[20px]">
                    <div className="w-full h-[40px] flex items-center rounded-[22px] bg-white border border-gray-300 shadow-sm font-poppins text-[15px] text-gray-main overflow-hidden">

                        {/* Button on the left */}
                        <button
                            type="button"
                            onClick={() => excelInputRef.current?.click()}
                            className="h-full w-40 bg-deep-blue text-white px-4 font-poppins text-[15px] hover:bg-deep-blue focus:outline-none"
                        >
                            Choose File
                        </button>

                        {/* File name to the right */}
                        <span className="pl-4 pr-5 truncate w-full">
                            {excelFileName || "No file chosen"}
                        </span>
                    </div>

                    {/* Hidden actual input */}
                    <input
                        type="file"
                        accept="*"
                        onChange={handleFileChange}
                        ref={excelInputRef}
                        className="hidden"
                    />
                </div>
            </div>

            <div>
                <span className="font-poppins pl-5 mb-[5px] font-semibold text-[15px] leading-[22px] tracking-[0px] align-middle">
                    Upload the ZIP:
                </span>

                <div className="relative w-full mt-[5px] mb-[20px]">
                    <div className="w-full h-[40px] flex items-center rounded-[22px] bg-white border border-gray-300 shadow-sm font-poppins text-[15px] text-gray-main overflow-hidden">

                        {/* Button on the left */}
                        <button
                            type="button"
                            onClick={() => zipInputRef.current?.click()}
                            className="h-full w-40 bg-deep-blue text-white px-4 font-poppins text-[15px] hover:bg-deep-blue focus:outline-none"
                        >
                            Choose File
                        </button>

                        {/* File name to the right */}
                        <span className="pl-4 pr-5 truncate w-full">
                            {zipFileName || "No file chosen"}
                        </span>
                    </div>

                    {/* Hidden file input */}
                    <input
                        type="file"
                        accept=".zip"
                        onChange={handleZipFileChange}
                        ref={zipInputRef}
                        className="hidden"
                    />
                </div>
            </div>

            {/* Upload button at the bottom */}
            <div className="flex justify-center">
                <button
                    id="uploadImageButton"
                    className="w-[150px] h-[60px] min-w-[150px] gap-[10px] rounded-[22px] px-[24px] py-[10px] text-white transition-all duration-1000 bg-gradient-to-r from-[#C300A0] to-[#00B4D2] group-hover:from-[#00B4D2] group-hover:to-[#C300A0]"
                    onClick={handleUploadClick}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden"></span>
                            </div>
                            <span style={{ marginLeft: '8px' }}>Uploading...</span>
                        </>
                    ) : 'Upload'}
                </button>
            </div>
        </div>
    );

}

export default ImageBUlkUpload;
